
const th_TH = {
  "产品菜单": "สินค้า",
  "关于我们菜单": "เกี่ยวกับเรา",
  "帮助中心菜单": "ศูนย์ช่วยเหลือ",
  "信用基础": "ความน่าเชื่อถือเป็นพื้นฐาน",
  "加密支付": "การชำระเงินเข้ารหัส",
  "全币种支持": "รองรับทุกสกุลเงิน",
  "全节点承兑": "การแลกเปลี่ยนแบบโหนดเต็ม",
  "去中心担保": "การค้ำประกันแบบกระจายศูนย์",
  "立即开始使用": "เริ่มใช้งานทันที",
  "闪电般的支付体验": "ประสบการณ์การชำระเงินที่รวดเร็วปานสายฟ้า",
  "完成跨境支付": "ทำธุรกรรมข้ามประเทศภายใน 45 วินาที",
  "多链支持": "รองรับหลายบล็อกเชน",
  "支持主流公链资产": "รองรับสินทรัพย์บนเครือข่ายหลัก",
  "实时结算": "การชำระเงินแบบเรียลไทม์",
  "无需等待": "โอนเสร็จภายในไม่กี่วินาที ไม่ต้องรอ",
  "超额担保": "การค้ำประกันเกินมูลค่า",
  "资金安全有保障": "เงินทุนปลอดภัยและได้รับการคุ้มครอง",
  "一个钱包": "กระเป๋าเงินเดียว",
  "所有可能": "ทุกสิ่งเป็นไปได้",
  "商户收款": "การรับเงินของร้านค้า",
  "全球化支付网关": "เกตเวย์การชำระเงินระดับโลก",
  "承兑服务": "บริการรับแลกเปลี่ยน",
  "稳定可靠的承兑网络": "เครือข่ายการแลกเปลี่ยนที่เสถียรและเชื่อถือได้",
  "数字资产": "สินทรัพย์ดิจิทัล",
  "多链资产管理": "การจัดการสินทรัพย์หลายบล็อกเชน",
  "下载": "ดาวน์โหลดแอป",
  "多节点承兑": "การแลกเปลี่ยนหลายโหนด",
  "生态": "ระบบนิเวศ NECO",
  "钱包": "TEPAY Wallet",
  "立即下载": "ดาวน์โหลดทันที",
  "随时汇币": "โอนข้ามประเทศได้ทุกที่ทุกเวลา",
  "走天下": "ใช้งานได้ทั่วโลก",
  "海量订单": "คำสั่งซื้อมหาศาล",
  "日进斗金": "ทำกำไรทุกวัน",
  "首页描述": "TePay เป็นโครงสร้างพื้นฐานการชำระเงินแบบกระจายศูนย์ ไม่ใช่ธนาคาร บริการทางการเงินดำเนินการโดยเครือข่ายโหนดและสัญญาอัจฉริยะบนบล็อกเชน กลไกการค้ำประกันและเครดิตทำให้มั่นใจได้ว่าธุรกรรมปลอดภัยและถูกกฎหมาย การดูแลและการแก้ไขข้อพิพาทจัดการโดยระบบ DAO โมดูลการทำงานร่วมกันหลายบล็อกเชนและการปฏิบัติตามกฎระเบียบ ช่วยให้ผู้ใช้และร้านค้าได้รับประสบการณ์การชำระเงินที่โปร่งใสและราบรื่น",
  "轻松交易": "การซื้อขายที่ง่ายดาย",
  "slide2Text": "ทำการแลกเปลี่ยนสกุลเงินดิจิทัลและเงินสดได้อย่างอิสระ ผ่านเครือข่ายหลายโหนดของ TePay",
  "slide2Info": "TePay เป็นแพลตฟอร์มการชำระเงินแบบกระจายศูนย์ ไม่ใช่ธนาคารแบบดั้งเดิม บริการดำเนินการโดยเครือข่ายการแลกเปลี่ยนหลายโหนดและได้รับการคุ้มครองโดยสัญญาอัจฉริยะบนบล็อกเชน การค้ำประกันเกินมูลค่าและกลไกการให้คะแนนเครดิตทำให้มั่นใจได้ว่าธุรกรรมแต่ละรายการมีความปลอดภัยและถูกกฎหมาย",
  "全球通用": "ใช้ได้ทั่วโลก",
  "让每一笔支付": "ทำให้การชำระเงินทุกครั้ง",
  "瞬间达成": "สำเร็จภายในเสี้ยววินาที",
  "slide3Text": "ซื้อขายสกุลเงินดิจิทัลและเงินสดได้อิสระในเครือข่ายอันทรงพลังของ TePay",
  "slide3Info": "TePay ไม่จำกัดเพียงสกุลเงินเดียว แพลตฟอร์มแบบกระจายศูนย์ช่วยให้คุณส่ง รับ และแลกเปลี่ยนสกุลเงินหลายชนิดได้อย่างง่ายดาย ข้ามขอบเขตประเทศและเพลิดเพลินกับประสบการณ์ที่เป็นหนึ่งเดียว ด้วยเทคโนโลยีบล็อกเชนและกลไกเครดิตแบบไดนามิก เงินของคุณจะปลอดภัยและมีประสิทธิภาพเสมอ",
  "护航每笔交易": "ปกป้องทุกธุรกรรม",
  "安全无忧": "ปลอดภัยไร้กังวล",
  "slide4Text": "ด้วยกลไกการค้ำประกันแบบกระจายศูนย์ เพื่อสร้างความมั่นใจและความปลอดภัยในทุกธุรกรรม",
  "slide4Info": "TePay ไม่ใช่ธนาคารแบบดั้งเดิม แต่ใช้กลไกการค้ำประกันแบบกระจายศูนย์เพื่อทำให้มั่นใจว่าธุรกรรมปลอดภัย ระบบใช้การค้ำประกันเกินมูลค่า การให้คะแนนเครดิตแบบไดนามิก และการอนุญาโตตุลาการ DAO เพื่อสร้างหลักประกันที่แข็งแกร่ง เชื่อมต่อการเงินดั้งเดิมกับสินทรัพย์ดิจิทัลอย่างมีประสิทธิภาพ",
  "一个钱包走天下": "กระเป๋าเดียวใช้ได้ทั่วโลก",
  "币随时付": "ชำระด้วยเหรียญได้ทุกเวลา",
  "跨境无忧": "ข้ามพรมแดนไร้กังวล",
  "slide5Text": "จัดการสินทรัพย์ทั้งหมดได้ในที่เดียว ไม่ว่าจะเป็นเงินสดหรือดิจิทัล",
  "slide5Info": "TePay รวมโลกการเงินของคุณไว้ในที่เดียว ผ่านกระเป๋าเงินเดียวที่ตอบโจทย์ทุกการชำระเงิน แพลตฟอร์มรวมการจัดการสินทรัพย์และการทำธุรกรรมทั่วโลก อาศัยเทคโนโลยีบล็อกเชนและกลไกเครดิตแบบไดนามิก เพื่อมอบประสบการณ์ทางการเงินที่ไร้รอยต่อและมีประสิทธิภาพ",
  "slide6Text": "ตอบโจทย์ความต้องการหลายสกุลเงินของร้านค้าและลูกค้า กำไรไร้ขีดจำกัด",
  "slide6Info": "กลไกการจับคู่แบบไดนามิกของ TePay เชื่อมการเงินระหว่างเงินสดและดิจิทัล ทำให้โหนดแลกเปลี่ยนสามารถทำกำไรได้ไม่ว่าสกุลเงินใดจะถูกใช้ แพลตฟอร์มชำระเงินอย่างมีประสิทธิภาพ ทุกธุรกรรมช่วยให้รายได้ของคุณเพิ่มขึ้น",
  "边兑边赚": "แลกเปลี่ยนพร้อมทำกำไร",
  "信用随行": "เครดิตติดตามคุณ",
  "slide7Text": "ทุกการแลกเปลี่ยนเพิ่มผลกำไร พร้อมเสริมสร้างเครดิตของคุณ",
  "slide7Info": "TePay ไม่ใช่ธนาคารแบบดั้งเดิม แต่ใช้กลไกการค้ำประกันแบบกระจายศูนย์เพื่อทำให้มั่นใจว่าธุรกรรมปลอดภัย ระบบใช้การค้ำประกันเกินมูลค่า การให้คะแนนเครดิตแบบไดนามิก และการอนุญาโตตุลาการ DAO เพื่อสร้างหลักประกันที่แข็งแกร่ง",
  "下载TEPAY": "ดาวน์โหลด TEPAY",
  "开启信用支付": "เริ่มต้นการชำระด้วยเครดิต",
  "多币种支持": "รองรับหลายสกุลเงิน",
  "多节点承兑描述": "การแลกเปลี่ยนหลายโหนด",
  "下载Text": "ดาวน์โหลด",
  "链上赋能": "บล็อกเชนเสริมพลังให้กับอีคอมเมิร์ซชุมชน",
  "品牌即社区": "แบรนด์คือชุมชน",
  "消费即投资": "การบริโภคคือการลงทุน",
  "本地即全球": "ท้องถิ่นก็คือระดับโลก",
  "真实消费": "การบริโภคจริง",
  "支撑返利": "การสนับสนุนผลตอบแทน",
  "slide2Text": "ยิ่งซื้อมาก ยิ่งได้คืนจริง",
  "slide2Info": "NECO จะสร้างโทเค็นและแต้มเฉพาะเมื่อคำสั่งซื้อเสร็จสมบูรณ์และยืนยันบนบล็อกเชนแล้ว ผลตอบแทนถูกจำกัดที่ส่วนลดร้านค้า 20% ไม่มีการออกเกิน หมายความว่ารางวัลทั้งหมดได้รับการสนับสนุนโดยกระแสเงินสดจริง ทุกธุรกรรม NECO/USAI สามารถตรวจสอบบนบล็อกเชนได้",
  "透明积分": "แต้มโปร่งใส",
  "代币经济": "เศรษฐกิจโทเค็น",
  "slide3Text": "แต้มบนบล็อกเชน มูลค่ายืนยันได้",
  "slide3Info1": "ผลตอบแทนจากการบริโภคถูกแบ่งออกเป็น NECO Token และ USAI Stablecoin",
  "slide3Info2": "NECO ปล่อยทีละ 0.2% ต่อวัน ส่วน USAI จะปรับอัตราโดยการเผาหรือสร้างใหม่",
  "slide3Info3": "ทุกการสร้าง เผา และปล่อย ถูกบันทึกโดยสัญญาอัจฉริยะ ทุกคนสามารถตรวจสอบยอดเงิน กระบวนการปล่อย และประวัติธุรกรรมได้แบบเรียลไทม์",
  "多角色": "หลายบทบาท",
  "激励生态": "ระบบนิเวศที่มีแรงจูงใจ",
  "slide4Text1": "ผู้ใช้ หัวหน้ากลุ่ม ร้านค้า วงจรที่ชนะร่วมกัน",
  "slide4Info1": "ผู้ใช้: ได้รับแต้มคืนเต็มจำนวน ถือ NECO มีสิทธิ์โหวตและกำไร",
  "slide4Info2": "หัวหน้ากลุ่ม: จัดกลุ่ม ซื้อขาย ดูแลชุมชน รับค่าคอม + รางวัล NECO",
  "slide4Info3": "ร้านค้า: มอบส่วนลดเพื่อได้คำสั่งซื้อแม่นยำ ค่าธรรมเนียม 0% และการโปรโมทแบรนด์",
  "slide4Info4": "ทั้งสามฝ่ายถูกเขียนลงในสูตรเดียวกันบนบล็อกเชน รายรับและค่าใช้จ่ายตรวจสอบได้แบบเรียลไทม์",
  "合规保障": "การคุ้มครองตามกฎระเบียบ",
  "全程可审": "ตรวจสอบได้ตลอดเวลา",
  "slide5Text": "ธุรกรรมบนบล็อกเชน เป็นมิตรต่อการกำกับดูแล",
  "slide5Info1": "TePay Gateway ทำหน้าที่ KYC การเชื่อมต่อเงินสด และการปฏิบัติตามกฎการชำระเงิน",
  "slide5Info2": "แพลตฟอร์มมี Oracle คู่ พื้นที่บัฟเฟอร์ราคา และกองทุน DAO เพื่อจัดการความเสี่ยง สามารถเปิดใช้มาตรการ เช่น จำกัดความเร็ว ซื้อคืน หรือหยุดชั่วคราวเมื่อเกิดเหตุการณ์รุนแรง",
  "合作伙伴": "พันธมิตร",
  "社区团购": "การซื้อรวมของชุมชน",
  "社区小店": "ร้านเล็กของชุมชน",
  "社区空间": "พื้นที่ชุมชน",
  "社区服务": "บริการชุมชน",
  "NECO优选": "NECO เลือกสรร",
  "暂未开放": "ยังไม่เปิด",
  "新闻标题": "ศูนย์ข่าว",
  "新闻1标题": "ประกาศการเปิดตัว แอป และระบบสมาชิก",
  "新闻1内容": "ถึงสมาชิกทุกท่าน:\n\nเราจะเปิดคู่การซื้อขาย NECO/nUSDT และ USAI/nUSDT บน Novai SWAP เวลา 24:00 น. (GMT+8) วันที่ 5 สิงหาคม เพื่อเริ่มต้นแพลตฟอร์ม\n\nพร้อมกันนี้ NECO APP จะเปิดให้ลงทะเบียนอย่างเป็นทางการ และระบบสมาชิกทั่วโลกจะออนไลน์ คุณสามารถ:\n1. ลงทะเบียนผู้ใช้และแชร์ลิงก์\n2. เติม USDT เพื่อรับ USAI และซื้อ VIP\n3. ปลดล็อกแต้มของโหนดสร้างและโหนดปกติ\n4. รับรางวัลแนะนำสมาชิกและจัดการทีม\n5. ปลดล็อกแต้มเป็น NECO\n6. แลก NECO เป็น USAI และถอน (เวอร์ชันนี้ถอน USDT ได้)\n7. ใช้ฟังก์ชันพื้นฐาน เช่น ตรวจราคา NECO ตรวจคู่ซื้อขาย SWAP และดูประกาศ\n\nหากมีการเปลี่ยนเวลา เราจะแจ้งประกาศเพิ่มเติม",
  "返回": "กลับ",
  "消费返股": "การบริโภคคืนหุ้น",
  "全球首个": "ครั้งแรกของโลก",
  "WEB3社区电商平台": "แพลตฟอร์มอีคอมเมิร์ซชุมชน WEB3",
  "消费": "บริโภค",
  "赚钱": "หาเงิน",
  "持股": "ถือหุ้น",
  "合伙人": "พาร์ทเนอร์",
  "用户": "ผู้ใช้",
  "股东": "ผู้ถือหุ้น",
  "不只是电商": "ไม่ใช่แค่อีคอมเมิร์ซ",
  "更是社区电商": "แต่คืออีคอมเมิร์ซชุมชน",
  "共赢闭环": "ผู้ใช้ หัวหน้า ร้านค้า วงจรที่ชนะร่วมกัน",
  "用户描述": "ผู้ใช้: ได้แต้มคืนเต็ม ถือ NECO มีสิทธิ์และผลกำไร",
  "团长描述": "หัวหน้า: จัดการกลุ่ม รับคอมมิชชั่น + NECO",
  "商户描述": "ร้านค้า: ลดราคา รับคำสั่งซื้อที่แม่นยำ ไม่มีค่าธรรมเนียม และโปรโมทแบรนด์",
  "三方描述": "ทั้งสามฝ่ายตรวจสอบได้แบบเรียลไทม์บนบล็อกเชน",
  "购物聊天": "NECO AI ทำให้การช้อปปิ้งง่ายเหมือนการแชท",
  "边聊边选": "แชทและเลือกสินค้า",
  "聊天助手实时理解你的对话": "ผู้ช่วย AI เข้าใจการสนทนาของคุณแบบเรียลไทม์",
  "就能找到你要的东西": "แค่พูด ก็หาสิ่งที่คุณต้องการได้",
  "AI优选": "AI เลือกสรร",
  "的那一刻": "เมื่อคุณเปิด NECO",
  "已经在等你": "สินค้าที่เหมาะกับคุณ รออยู่แล้ว",
  "时尚分身": "ผู้ช่วยแฟชั่น",
  "监控价格": "ค้นหาสินค้า เฝ้าราคาสำหรับคุณ",
  "守护你的消费体验": "ปกป้องประสบการณ์การช้อปปิ้งของคุณ",
  "三类团购机制": "3 กลไกการซื้อรวม",
  "附近团": "กลุ่มใกล้เคียง",
  "熟人团": "กลุ่มเพื่อน",
  "优选团": "กลุ่มคัดสรร",
  "全球战略布局": "กลยุทธ์ระดับโลก",
  "使命与愿景": "พันธกิจและวิสัยทัศน์",
  "使命": "พันธกิจ",
  "愿景": "วิสัยทัศน์",
  "使命描述": "สร้างระบบธุรกิจที่โปร่งใส ยุติธรรม และมีส่วนร่วม",
  "愿景描述": "ให้ทุกมุมโลกสว่างด้วยเศรษฐกิจชุมชน",
  "公告": "ประกาศ",
  "铸造销毁协议": "สัญญาการสร้างและเผา",
  "SWAP交易": "การซื้อขาย SWAP",
  "NECO社区电商": "NECO อีคอมเมิร์ซชุมชน",
  "菜单": "เมนู",
  "安卓下载": "ดาวน์โหลด Android",
  "ios下载": "ดาวน์โหลด iOS",
  "NECO下载": "ดาวน์โหลดแอป NECO",
  "支持版本": "รองรับ iOS และ Android",
  "当前版本": "เวอร์ชันปัจจุบัน",
  "跨链桥": "สะพานข้ามบล็อกเชน",
  "合作伙伴关系": "ความร่วมมือทางธุรกิจ",
  "请加入社交媒体信息": "โปรดเข้าร่วมข้อมูลสื่อสังคมออนไลน์",
  "联系我们": "ติดต่อเรา",
  "版权所有（公司）": "ลิขสิทธิ์ (บริษัท)",
  "联系我们的邮件请填写": "ข้อความติดต่อเรากรุณากรอก",
  "新闻": "ข่าว",
  "网页直连": "หน้าเว็บเชื่อมต่อโดยตรง",
  "铸造与销毁协议": "โปรโตคอลการหล่อและการทำลาย",
  "更多": "เพิ่มเติม",
  "请通过": "โปรดผ่าน",
  "与我们联系": "ติดต่อเรา",
  "版权所有": "ลิขสิทธิ์",
  "联系": "ติดต่อ",
  "智能体": "แชทบอท",

  
  "全球首个": "รายแรกของโลก",
  "WEB3社区电商平台": "แพลตฟอร์มอีคอมเมิร์ชชุมชน WEB3",
  "消费": "บริโภค",
  "持股": "ถือหุ้น",
  "升值": "เพิ่มมูลค่า",
  "重新定义消费的价值": "นิยามใหม่ของคุณค่าการบริโภค",
  "让消费成为财富的起点": "ให้การบริโภคเป็นจุดเริ่มต้นของความมั่งคั่ง",
  "消费即拥有，分享即收益": "บริโภค = เป็นเจ้าของ, แบ่งปัน = ได้รับผลประโยชน์",
  "NECO 是一套基于 Web3 技术的智能电商基础设施，通过「消费即持股」机制，让每一位用户在购物时获得真实权益与长期回报。 在这里，消费者不只是用户，更是平台的拥有者和生态的建设者。": "NECO เป็นโครงสร้างพื้นฐานอีคอมเมิร์ชอัจฉริยะที่อ้างอิงจากเทคโนโลยี Web3 ผ่านกลไก \"บริโภคคือถือหุ้น\" ทำให้ผู้ใช้ทุกคนได้รับสิทธิประโยชน์ที่แท้จริงและผลตอบแทนระยะยาวเมื่อช็อปปิ้ง ที่นี่ ผู้บริโภคไม่ใช่แค่ผู้ใช้งาน แต่เป็นเจ้าของแพลตฟอร์มและผู้สร้างระบบนิเวศ",
  "核心技术": "เทคโนโลยีหลัก",
  "基于 Novai Chain 的二层网络": "เครือข่ายชั้นสองบนพื้นฐานของ Novai Chain",
  "Neco Chain 是构建在 Novai Chain 之上的高性能二层网络，": "Neco Chain เป็นเครือข่ายชั้นสองประสิทธิภาพสูงที่สร้างขึ้นบน Novai Chain",
  "专为高频电商与支付结算设计，平均出块时间仅 0.2 秒，TPS 超过 50,000。": "ออกแบบมาโดยเฉพาะสำหรับอีคอมเมิร์ชความถี่สูงและการชำระเงิน ด้วยเวลาการสร้างบล็อกเฉลี่ยเพียง 0.2 วินาที TPS เกิน 50,000",
  "Neco Chain 将电商的每笔消费行为与激励记录上链，": "Neco Chain บันทึกพฤติกรรมการบริโภคและการให้แรงจูงใจทุกครั้งในอีคอมเมิร์ชลงบล็อกเชน",
  "让商业行为具备长期可验证性与可追溯性。": "ทำให้พฤติกรรมทางธุรกิจมีความสามารถในการตรวจสอบและการติดตามระยะยาว",
  "高速并行账本结构": "โครงสร้างบันทึกคู่ขนานความเร็วสูง",
  "智能结算与动态费用调节": "การชำระเงินอัจฉริยะและการปรับค่าธรรมเนียมแบบไดนามิก",
  "消费凭证 NFT 化与积分资产化": "การแปลงใบรับรองการบริโภคเป็น NFT และการแปลงคะแนนเป็นสินทรัพย์",
  "核心特性": "คุณสมบัติหลัก",
  "链上结算": "การชำระเงินบนเชน",
  "每笔电商交易 0.2 秒确认，安全透明": "ธุรกรรมอีคอมเมิร์ชทุกครั้งยืนยันใน 0.2 วินาที ปลอดภัยและโปร่งใส",
  "激励协议": "โพรโทคอลแรงจูงใจ",
  "激励消费者、商家、渠道等为NECO做出贡献": "กระตุ้นให้ผู้บริโภค ร้านค้า ช่องทาง และอื่นๆ สนับสนุน NECO",
  "权益积分": "คะแนนสิทธิประโยชน์",
  "用户消费即持有可追踪、可变现的权益积分": "ผู้ใช้บริโภคคือการถือครองคะแนนสิทธิประโยชน์ที่ติดตามและแปลงเป็นเงินได้",
  "共建共享": "สร้างร่วมกัน แบ่งปันร่วมกัน",
  "首个去中心商业自治组织，共建共享NECO电商": "องค์กรปกครองตนเองทางธุรกิจแบบกระจายอำนาจรายแรก สร้างร่วมกัน แบ่งปันร่วมกัน อีคอมเมิร์ช NECO",
  "主要产品": "ผลิตภัณฑ์หลัก",
  "支持电商 RWA 的高性能公链": "บล็อกเชนสาธารณะประสิทธิภาพสูงที่รองรับ RWA อีคอมเมิร์ช",
  "稳定币、DEX、去中心信用等电商基础协议": "สกุลเงินสเตเบิล DEX ระบบเครดิตแบบกระจายอำนาจ และโพรโทคอลพื้นฐานอีคอมเมิร์ชอื่นๆ",
  "同时为WEB2和WEB3用户服务的电商APP": "แอปอีคอมเมิร์ชที่ให้บริการแก่ผู้ใช้ WEB2 และ WEB3 พร้อมกัน",
  "法币和数字货币统一支付及结算体系": "ระบบการชำระเงินและการชำระหนี้แบบรวมศูนย์ของเงินเฟียตและเงินดิจิทัล",
  "竞争优势": "ข้อได้เปรียบในการแข่งขัน",
  "极速公链": "บล็อกเชนสาธารณะความเร็วสุดโต่ง",
  "0.2 秒出块，支持百万级并发订单及支付交易。": "สร้างบล็อก 0.2 วินาที รองรับคำสั่งซื้อและการชำระเงินพร้อมกันระดับล้านครั้ง",
  "全球合规": "การปฏิบัติตามกฎระเบียบระดับโลก",
  "在全球各地通过 DAO 组织进行本地合规运营。": "ดำเนินงานที่ปฏิบัติตามกฎระเบียบระดับท้องถิ่นผ่านองค์กร DAO ทั่วโลก",
  "电商 RWA": "RWA อีคอมเมิร์ช",
  "第一个将现实世界电商完全放在链上运行的平台。": "แพลตฟอร์มรายแรกที่นำอีคอมเมิร์ชโลกจริงมาดำเนินการบนเชนอย่างสมบูรณ์",
  "商业闭环": "วงจรปิดทางธุรกิจ",
  "让消费、社交与收益形成价值闭环。": "ให้การบริโภค สังคม และผลกำไรสร้างวงจรคุณค่า",
  "全球分销体系让每个用户都能成为品牌的传播者与收益方。": "ระบบการจัดจำหน่ายทั่วโลกทำให้ผู้ใช้ทุกคนกลายเป็นผู้เผยแพร่แบรนด์และผู้ได้รับผลประโยชน์",
  "消费者端": "ฝั่งผู้บริโภค",
  "注册/消费即得积分奖励，积分每日释放为资产。": "ลงทะเบียน/บริโภครับรางวัลคะแนนทันที คะแนนปลดล็อกเป็นสินทรัพย์ทุกวัน",
  "商家端": "ฝั่งร้านค้า",
  "一键接入结算 API，设置折让比例与积分政策。": "เชื่อมต่อ API การชำระเงินด้วยคลิกเดียว ตั้งค่าสัดส่วนส่วนลดและนโยบายคะแนน",
  "分销端": "ฝั่งการจัดจำหน่าย",
  "允许全球用户参与分销，共享收益与品牌成长。": "อนุญาตให้ผู้ใช้ทั่วโลกเข้าร่วมการจัดจำหน่าย แบ่งปันผลกำไรและการเติบโตของแบรนด์",
  "NECO 生态系统": "ระบบนิเวศ NECO",
  "一个融合金融、科技与商业的去中心化生态。": "ระบบนิเวศแบบกระจายอำนาจที่ผสานการเงิน เทคโนโลยี และธุรกิจเข้าด้วยกัน",
  "Neco Chain 公链": "บล็อกเชนสาธารณะ Neco Chain",
  "商业级高速 Layer 2 网络（Novai L2），提供结算与数据验证基础设施。": "เครือข่ายเลเยอร์ 2 ความเร็วสูงระดับธุรกิจ (Novai L2) ให้โครงสร้างพื้นฐานการชำระเงินและการตรวจสอบข้อมูล",
  "NECO App": "แอป NECO",
  "用户购物、签到、邀请与分销的统一入口。": "ทางเข้ารวมสำหรับการช็อปปิ้ง การเช็กอิน การเชิญ และการจัดจำหน่ายของผู้ใช้",
  "USAI 稳定币": "สกุลเงินสเตเบิล USAI",
  "用于平台内支付与结算的稳定币资产，锚定美元价值。": "สินทรัพย์สกุลเงินสเตเบิลสำหรับการชำระเงินและการชำระหนี้ภายในแพลตฟอร์ม มีค่าเงินผูกกับดอลลาร์สหรัฐ",
  "U Card 全球消费卡": "บัตรบริโภคทั่วโลก U Card",
  "连接线上线下消费场景，支持积分抵扣与现金返还。": "เชื่อมต่อสถานการณ์บริโภคออนไลน์และออฟไลน์ รองรับการหักคะแนนและคืนเงิน",
  "NECO AI 智能系统": "ระบบอัจฉริยะ NECO AI",
  "通过 AI 分析用户行为，实现个性化推荐与安全风控。": "ผ่าน AI วิเคราะห์พฤติกรรมผู้ใช้ ทำให้เกิดการแนะนำส่วนบุคคลและการควบคุมความเสี่ยงด้านความปลอดภัย",
  "消费金融该协议": "โพรโทคอลการเงินบริโภค",
  "提供通用的去中心化金融基础设施，支持电商资产流通。": "ให้โครงสร้างพื้นฐานการเงินแบบกระจายอำนาจทั่วไป รองรับการไหลเวียนของสินทรัพย์อีคอมเมิร์ช",
  "稳定币生态": "ระบบนิเวศสกุลเงินสเตเบิล",
  "构建覆盖支付、结算与跨境流通的稳定币网络。": "สร้างเครือข่ายสกุลเงินสเตเบิลที่ครอบคลุมการชำระเงิน การชำระหนี้ และการไหลเวียนข้ามพรมแดน",
  "团队及投资人": "ทีมและนักลงทุน",
  "全球化视野 · 多元化背景。": "มุมมองระดับโลก · พื้นฐานหลากหลาย",
  "NECO 团队成员来自新加坡、中国、阿联酋等地，拥有电商、金融科技与区块链技术领域超过十年的行业经验。": "สมาชิกทีม NECO มาจากสิงคโปร์ จีน สหรัฐอาหรับเอมิเรตส์ และที่อื่นๆ มีประสบการณ์อุตสาหกรรมมากกว่าสิบปีในด้านอีคอมเมิร์ช เทคโนโลยีการเงิน และเทคโนโลยีบล็อกเชน",
  "投资人": "นักลงทุน",
  "运营团队": "ทีมปฏิบัติการ",
  "Moe Farmani": "Moe Farmani",
  "拥有多年欧洲、中东、南美零售企业创业经验,曾创建迪拜领先的数字货币交易所 加密货币的重度信仰者": "มีประสบการณ์การเริ่มต้นธุรกิจค้าปลีกในยุโรป ตะวันออกกลาง และอเมริกาใต้หลายปี เคยสร้างตลาดแลกเปลี่ยนสกุลเงินดิจิทัลชั้นนำในดูไบ เป็นผู้ศรัทธาอย่างแรงกล้าในสกุลเงินคริปโต",
  "Matt Romman": "Matt Romman",
  "从事迪拜房地产和零售行业多年。拥有丰富的跨国公司管理经验。": "ทำงานในอุตสาหกรรมอสังหาริมทรัพย์และการค้าปลีกในดูไบหลายปี มีประสบการณ์การจัดการบริษัทข้ามชาติที่อุดมสมบูรณ์",
  "Alex Eric": "Alex Eric",
  "曾任职OKX，负责公司品牌和战略": "เคยทำงานที่ OKX รับผิดชอบแบรนด์และกลยุทธ์ของบริษัท",
  "Manoharlal": "Manoharlal",
  "Novai Chain Founder， 全面支撑NECO技术落地。": "ผู้ก่อตั้ง Novai Chain สนับสนุนการใช้งานเทคโนโลยี NECO อย่างครอบคลุม",
  "官方路线图": "แผนงานอย่างเป็นทางการ",
  "2025 — 创世与启动": "2025 — การสร้างโลกและการเริ่มต้น",
  "2025 — 增长与市场拓展": "2025 — การเติบโตและการขยายตลาด",
  "2026 — 生态深化与 AI 赋能": "2026 — การเจาะลึกระบบนิเวศและการ赋能ด้วย AI",
  "上半年（Q2–Q3）": "ครึ่งปีแรก (Q2–Q3)",
  "完成白皮书、制度模型与产品原型开发": "เสร็จสิ้นการพัฒนาหนังสือสีขาว แบบจำลองระบบ และต้นแบบผลิตภัณฑ์",
  "组织九大社区进行创世启动": "จัดองค์กรชุมชนเก้าแห่งเพื่อดำเนินการเริ่มต้นการสร้างโลก",
  "完成 300 个节点招募，发行 NECO & USAI 代币，添加初始流动性池": "เสร็จสิ้นการรับสมัคร 300 โหนด ออกโทเคน NECO & USAI เพิ่มกลุ่มสภาพคล่องเริ่มต้น",
  "发布 NECO APP BETA 测试版": "เปิดตัวแอป NECO รุ่นทดสอบ BETA",
  "下半年（Q3–Q4）": "ครึ่งปีหลัง (Q3–Q4)",
  "全球社区运营中心部署完成": "การปรับใช้ศูนย์ปฏิบัติการชุมชนทั่วโลกเสร็จสมบูรณ์",
  "NECO 优选店铺与创世商户上线": "ร้านค้าที่เลือกและร้านค้าผู้สร้างโลก NECO เปิดตัว",
  "推动注册用户突破 10 万": "ผลักดันให้ผู้ใช้ที่ลงทะเบียนเกิน 100,000 คน",
  "启动空投及全球电商启动大会": "เริ่มต้นการแจกโทเคนฟรีและการประชุมเปิดตัวอีคอมเมิร์ชทั่วโลก",
  "Q4：好货推广 & 本地电商": "Q4: การส่งเสริมสินค้าดีและการค้าอิเล็กทรอนิกส์ท้องถิ่น",
  "上线「好货系统」并开放会员商家入驻": "เปิดตัว \"ระบบสินค้าดี\" และเปิดให้ร้านค้าสมาชิกเข้าร่วม",
  "在主要国家开通 TePay 法币支付": "เปิดใช้งานการชำระเงินด้วยเงินเฟียต TePay ในประเทศหลัก",
  "完成中国、韩国、越南 10 家 NECO Best 本地电商落地": "เสร็จสิ้นการเปิดตัวอีคอมเมิร์ชท้องถิ่น NECO Best 10 แห่งในจีน เกาหลีใต้ และเวียดนาม",
  "海外注册用户突破 50 万，VIP 用户突破 5 万": "ผู้ใช้ที่ลงทะเบียนต่างประเทศเกิน 500,000 คน ผู้ใช้ VIP เกิน 50,000 คน",
  "举办第二次社区电商大会，开放跨境卖家注册": "จัดประชุมอีคอมเมิร์ชชุมชนครั้งที่สอง เปิดการลงทะเบียนผู้ขายข้ามพรมแดน",
  "拓展中东、南美、非洲与欧洲本地市场，整合供应链": "ขยายตลาดท้องถิ่นตะวันออกกลาง อเมริกาใต้ แอฟริกา และยุโรป ผสานระบบห่วงโซ่อุปทาน",
  "注册用户突破 100 万，VIP 用户突破 10 万": "ผู้ใช้ที่ลงทะเบียนเกิน 1,000,000 คน ผู้ใช้ VIP เกิน 100,000 คน",
  "Q1–Q2：体系完善": "Q1–Q2: การปรับปรุงระบบให้สมบูรณ์",
  "跨境卖家突破 10 万，商家数量超 10 万": "ผู้ขายข้ามพรมแดนเกิน 100,000 คน จำนวนร้านค้าเกิน 100,000 ร้าน",
  "举办第一届 NECO 电商生态大会": "จัดประชุมระบบนิเวศอีคอมเมิร์ช NECO ครั้งแรก",
  "上线稳定币生态与信用体系": "เปิดตัวระบบนิเวศสกุลเงินสเตเบิลและระบบเครดิต",
  "注册用户突破 500 万，VIP 超过 20 万": "ผู้ใช้ที่ลงทะเบียนเกิน 5,000,000 คน VIP เกิน 200,000 คน",
  "Q3–Q4：智能升级": "Q3–Q4: การอัปเกรดอัจฉริยะ",
  "获得主要国家支付牌照，全面上线法币支付服务": "ได้รับใบอนุญาตชำระเงินของประเทศหลัก เปิดตัวบริการชำระเงินด้วยเงินเฟียตอย่างครอบคลุม",
  "上线 AI 选品与推荐功能": "เปิดตัวฟังก์ชันการเลือกสินค้าและการแนะนำด้วย AI",
  "商家信用、积分全面上链": "เครดิตของร้านค้า คะแนน ขึ้นเชนอย่างสมบูรณ์",
  "NECO Best 优选商家突破 100 家": "ร้านค้าที่เลือก NECO Best เกิน 100 ร้าน",
  "注册用户突破 1000 万，VIP 超过 50 万": "ผู้ใช้ที่ลงทะเบียนเกิน 10,000,000 คน VIP เกิน 500,000 คน",
  "加入 NECO": "เข้าร่วม NECO",
  "消费创造财富，社区共建共享。": "การบริโภคสร้างความมั่งคั่ง ชุมชนร่วมสร้างและแบ่งปัน",
  "一分钟带你了解NECO": "หนึ่งนาทีพาคุณไปรู้จัก NECO",
  "NECO 通过链上透明的返利机制，让每一次消费都能获得真实收益。": "NECO ช่วยให้ทุกการใช้จ่ายได้รับประโยชน์จริงผ่านกลไกการคืนเงินที่โปร่งใสในห่วงโซ่",
  "相比传统电商，NECO 的利润由智能合约按比例即时返还，0 抽佣、0 压货。": "เมื่อเทียบกับอีคอมเมิร์ซแบบดั้งเดิมกำไรของ NECO จะถูกส่งกลับทันทีตามสัดส่วนตามสัญญาอัจฉริยะ, 0 ปั๊มค่าคอมมิชชั่น, 0 ความดัน",
  "用户与商家共享增长红利。": "ผู้ใช้แบ่งปันโบนัสการเติบโตกับร้านค้า",
  "全球版": "ระบบอีคอมเมิร์ชทั่วโลก",
  "中国版": "ระบบอีคอมเมิร์ชในประเทศจีน",

}

export default th_TH



// WEBPACK FOOTER //
// ./src/i18n/config/th_TH.js